import { render, staticRenderFns } from "./ProductSpecific.vue?vue&type=template&id=5d824ece&scoped=true"
import script from "./ProductSpecific.vue?vue&type=script&lang=js"
export * from "./ProductSpecific.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecific.vue?vue&type=style&index=0&id=5d824ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d824ece",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator})
